/* src/app/components/elibraryandcourse/purchase-course/purchase-course-details/purchase-course-details.component.css */
/*# sourceMappingURL=purchase-course-details.component.css.map */
